import type { UseFetchOptions } from "#app";
import { unref } from "#imports";

/**
 * Convert the query string parameters into a key for cache purposes
 * @param params The query string parameters
 */
export function apiQueryToKey<T> ( params: UseFetchOptions<T>["params"] ) {
  const input = unref( params );

  if ( !input ) {
    return "";
  }

  const obj: Record<string, string> = {};
  const keys = Object.keys( input ).sort();
  keys.forEach( ( x ) => {
    obj[x] = input[x];
  } );

  return JSON.stringify( obj ).toLowerCase();
}
